import { apiService } from '@/utils/api';
import type { SimpleDevice } from '@/types/api';

export interface UserSharedPermissionItem {
  fullAccess: boolean;
  readOnly: boolean;
  ownerShip: boolean;
}

export interface SharedUser {
  objectId: string;
  relation: 'Owner' | 'User' | 'Pending';
  inviteEmail: string;
  userName: string;
  permission: UserSharedPermissionItem;
  isPending: boolean;
}

export interface SharingListResult {
  owner: boolean;
  hasError: boolean;
  dataList: SharedUser[][]; // [owners, acceptedUsers, pendingUsers]
}

export interface Invitation {
  shareObjectId: string;
  name: string;
  email: string;
  deviceId: string;
  deviceLocation: string;
  deviceObjectId: string;
}

export async function getSharingList(deviceId: string): Promise<SharingListResult> {
  const data = await apiService.get<{ sharingList: SharingListResult }>(`/api/v1/iot-shadow/device/${deviceId}/sharingList`);
  return data.sharingList;
}

export async function getPendingInvitation(deviceId: string): Promise<Invitation[]> {
  const data = await apiService.get<{ invitationList: Invitation[] }>(`/api/v1/iot-shadow/device/${deviceId}/pendingInvitation`);
  return data.invitationList || [];
}

export async function getUnlinkedDeviceList(deviceId: string): Promise<SimpleDevice[]> {
  const data = await apiService.get<{ device_list: SimpleDevice[] }>(`/api/v1/iot-shadow/device/${deviceId}/unlinkedDeviceList`);
  return data.device_list || [];
}